import { render } from "./DeliverySection.vue?vue&type=template&id=535075e2&scoped=true"
import script from "./DeliverySection.vue?vue&type=script&lang=js"
export * from "./DeliverySection.vue?vue&type=script&lang=js"

import "./DeliverySection.vue?vue&type=style&index=0&id=535075e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535075e2"]])

export default __exports__